// WindowedCandidateViewer.tsx
import { useState } from 'react';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';

import Box from '@mui/material/Box';
import { Stack } from '@mui/system';
import { CircularProgress } from '@mui/material';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import { useAppSelector } from 'src/store/store';
import { useGetOrganizationCandidateQuery } from 'src/services/candidates/candidates.service';

import DraggableWindow from 'src/components/draggable-window/draggable-window';

import CandidateDetail from 'src/sections/candidates/view/candidate-detail-view';

interface Props {
  onClose: () => void;
}

export default function WindowedCandidateViewer({ onClose }: Props) {

  const router = useRouter();

  const [viewerError, setViewerError] = useState(false);

  const selectedCandidateId = useAppSelector((state) => state.app.candidateViewer.candidateId);

  const { currentData: orgCandidate, isFetching: isLoading } = useGetOrganizationCandidateQuery(
    selectedCandidateId as string,
    {
      skip: !selectedCandidateId,
    }
  );

  return (
    <DraggableWindow
      onClose={onClose}
      title={isLoading ? 'Loading...' : `${orgCandidate?.candidate_profile.first_name  } ${  orgCandidate?.candidate_profile.last_name}`}
      url={paths.dashboard.candidates.detail(selectedCandidateId as string)}
      maxWidth='50vw'
      adjustable
      maxHeight='80vh'
    >
      <Box minWidth="30vw" minHeight="40vh" p={2}>

        {(!viewerError && isLoading) && (
          <Stack justifyContent="center" alignItems="center" minWidth="30vw" minHeight="40vh">
            <CircularProgress />
          </Stack>
        )}

        {(!viewerError && !isLoading && orgCandidate) && (
          <CandidateDetail overrideCandidateId={selectedCandidateId} />
        )}

      </Box>
    </DraggableWindow>
  );
}